(function () {

  function openModal(id) {
    const modal = document.getElementById(id)
    if (!modal) return

    modal.classList.add('is-active')
    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('modal-open')
  }

  function closeModal(modal) {
    modal.classList.remove('is-active')
    modal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('modal-open')
  }

  // Abrir
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-modal-target]')
    if (!trigger) return

    const id = trigger.dataset.modalTarget
    if (!id) return

    e.preventDefault()
    openModal(id)
  })

  // Close
  document.addEventListener('click', e => {
    const closeTrigger = e.target.closest('[data-modal-close]')
    if (!closeTrigger) return

    const modal = closeTrigger.closest('.modal')
    if (!modal) return

    closeModal(modal)
  })

  // ESC
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return

    const modal = document.querySelector('.modal.is-active')
    if (modal) closeModal(modal)
  })

})()